/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import { ICittaPopUpCopyViewProps } from './citta-pop-up-copy';

export default (props: ICittaPopUpCopyViewProps) => {
    const {
        message,
        closeButton,
        image,
        cookieValue,
        MessageTextProps,
        isMobile,
        ImageTextProps,
        subscribeForm,
        SubscribeWrapper,
        subscribeResponse,
        responseSuccess,
        showResponseSuccess,
        formErrors,
        formErrorsNodeProps,
        successResponseNodeProps,
        showSuccessResponse,
        successResponse
    } = props;

    const {
        FormWrapper,
        FormContainer,
        // firstAndLastNameInput,
        emailInput,
        subscribeButtton,
        subscribeThanks,
        reCaptcha,
    } = subscribeForm;

    return (
        <div className={`citta-pop-up-copy ${cookieValue}`}>
            <div className={`citta-pop-up-copy__content  ${isMobile ? 'mobile' : 'desktop'}`}>
                <div className="close-pop-up">
                    {closeButton}
                </div>
                <div className={`citta-pop-up-copy__body ${isMobile ? 'mobile' : 'desktop'}`}>
                    {image && <Node {...ImageTextProps}><p>{image}</p></Node>}
                    {message && <Node {...MessageTextProps}>
                        <p>{message}</p>
                        <Module {...SubscribeWrapper} >
                            {subscribeResponse}
                            {showSuccessResponse ?
                                <Node {...successResponseNodeProps}>
                                    {successResponse}
                                </Node>
                                : <Node {...FormWrapper}>
                                    <Node {...FormContainer}>
                                        {/* {firstAndLastNameInput} */}
                                        {emailInput}
                                        {reCaptcha}
                                        {responseSuccess && showResponseSuccess ? subscribeThanks : subscribeButtton}
                                    </Node>
                                    <Node {...formErrorsNodeProps}>
                                        {formErrors}
                                    </Node>
                                </Node>
                            }
                        </Module>
                    </Node>}
                </div>
            </div>
        </div>
    );
};
